/**
 * LES VALEURS D'UNE DIMENSION SECONDAIRE, telles que l'écran les lit dans un champ « L30, L32, L34 ».
 *
 * ⚠️ MODULE PUR, SÉPARÉ DE L'ÉCRAN : c'est la seule partie de ce panneau qui DÉCIDE quelque chose
 * (l'ordre, les doublons, les vides), donc la seule qui mérite un test de comportement — et un test
 * ne doit pas avoir à monter un écran React pour vérifier une virgule.
 */

/**
 * « L30, L32, L34 » → la liste ORDONNÉE, sans vide ni doublon.
 * ⚠️ L'ORDRE DE SAISIE EST CONSERVÉ, jamais trié : c'est l'humain qui décide du rang, exactement comme
 * pour les tailles d'une grille. Un doublon garde sa PREMIÈRE place ; un vide (« L30,,L32 ») disparaît.
 */
export function parseDimensionValues(brut: string): string[] {
  const out: string[] = [];
  for (const v of brut.split(',')) {
    const t = v.trim();
    if (t !== '' && !out.includes(t)) out.push(t);
  }
  return out;
}
